import { useState, useEffect, useRef, useCallback } from 'react';

export interface UseChatNotificationsReturn {
  unreadCount: number;
  markAsRead: () => void;
  incrementUnread: () => void;
}

export function useChatNotifications(
  isChatOpen: boolean
): UseChatNotificationsReturn {
  const [unreadCount, setUnreadCount] = useState(0);
  const previousChatOpenRef = useRef(isChatOpen);

  useEffect(() => {
    if (isChatOpen && !previousChatOpenRef.current) {
      setUnreadCount(0);
    }
    previousChatOpenRef.current = isChatOpen;
  }, [isChatOpen]);

  const markAsRead = useCallback(() => {
    setUnreadCount(0);
  }, []);

  const incrementUnread = useCallback(() => {
    setUnreadCount((prev) => prev + 1);
  }, []);

  console.log('unreadCount', unreadCount);

  return {
    unreadCount,
    markAsRead,
    incrementUnread,
  };
}
